const utils = require('frontend-controller/lib/utils')

module.exports = {
	config: {
		useAttributeForPicker: ''
	},

	events: {
		click: function(event){
			event.preventDefault();
			event.stopImmediatePropagation();

			var self = event.data.component;
			var $target = $(event.target).closest('button');
			if($target.length > 0){
				var mode = $target.data('buttonMode');

				if(mode === 'empty'){
					self.empty();
				} else {
					utils.performButtonAction(event);
				}
			}
		}
	},

	methods: {

		showSelect: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			var blackListedEntityIDs = [];
			this.closest('base_form_form', function(form){
				var attributeName = (form.resourceData.data || {}).primaryKey || 'id'
				if(this.config.useAttributeForPicker){
					attributeName = this.config.useAttributeForPicker
				}
				var entityID = ((form.resourceData.data || {}).attributes || {})[attributeName]
				if(entityID){
					blackListedEntityIDs.push(entityID);
				}
			});
			this.performAndStoreAction(
				'showSelect_products_inEffect',
				this.prepareAction(
					'showSelect_products',
					undefined,
					{
						selectedRowIDs: this.model.dataJSON || [],
						blackListedEntityIDs
					}
				)
			)
		},

		empty: function(){
			var self = this;
			self.model.dataJSON = {}

			self.parent(function(parentComponent){
				parentComponent.fieldToModel(self.model.fieldCode, self.model.dataJSON);
				parentComponent.refresh();
			});
		}
	},

	hooks: {
		async onDecision($element, options){
			switch(options.decisionType){
				case 'submit':
					this.model.dataJSON = this.model.dataJSON || {}

					let table, parent
					options.decisionComponent.find('templates_mblx_products_table_table', c => table = c)
					this.parent(c => parent = c)

					if(table && table.config.isSelectionSource){
						if(options.decisionOptions.mode === 'useSelection'){
							this.model.dataJSON = table.getSelectedRowIDs(true) || {}
						} else if (options.decisionOptions.mode === 'useFiltered') {
							this.model.dataJSON = await table.getFilteredRowIDs()
						}

						if(parent){
							parent.fieldToModel(this.model.fieldCode, this.model.dataJSON)
							parent.refresh()
						}
					}
					break;

				case 'cancel':
					// do nothing
					break;
			}

			options.decisionComponent.hide();
		},

		onChildChanged: function($element, options){
			this.triggerClosest('onChildChanged', {
				fieldCode: this.model.fieldCode,
				value: options.value
			});
		}
	}
};